<aside class="rail">
  <section class="rail-card">
    <button
      type="button"
      class="rail-card-header"
      [attr.aria-expanded]="detailsExpanded()"
      [dataSelector]="'cxp-crl-overlay-rail-details-toggle'"
      (click)="toggleDetails()"
    >
      <h3 class="rail-card-title rail-card-title-strong">Details</h3>
      <aiwyn-icon
        class="rail-card-chevron"
        [class.rail-card-chevron-expanded]="detailsExpanded()"
        name="chevron-down"
        [height]="16"
        [width]="16"
      ></aiwyn-icon>
    </button>

    @if (detailsExpanded()) {
      <div class="rail-card-body">
        @if (dueDate(); as due) {
          <div class="rail-field" [dataSelector]="'cxp-crl-overlay-rail-due'">
            <span class="rail-field-label">Due on</span>
            <span class="rail-field-value">{{ due | safeDate: 'MMMM d, y' }}</span>
          </div>
        }

        @if (requestedBy(); as owner) {
          <div class="rail-group" [dataSelector]="'cxp-crl-overlay-rail-requested-by'">
            <span class="rail-field-label">Requested by</span>
            <div class="rail-person">
              <span class="rail-avatar rail-avatar--{{ memberAvatarColor(owner) }}" aria-hidden="true">
                {{ initialsForMember(owner) }}
              </span>
              <div class="rail-person-text">
                <p class="rail-person-name">{{ owner.name || owner.email || '—' }}</p>
                @if (owner.name && owner.email) {
                  <p class="rail-person-email">{{ owner.email }}</p>
                }
              </div>
            </div>
          </div>
        }

        <div class="rail-group">
          <div class="rail-group-header">
            <span class="rail-field-label">Client access</span>
            @if (canInvite()) {
              <button
                type="button"
                class="rail-invite"
                [dataSelector]="'cxp-crl-overlay-rail-invite'"
                (click)="invite.emit()"
              >
                Invite
              </button>
            }
          </div>
          <div class="rail-contacts">
            @for (contact of clientContacts(); track contact.key) {
              <div class="rail-person">
                <span class="rail-avatar-wrap" aria-hidden="true">
                  <span class="rail-avatar rail-avatar--{{ contactAvatarColor(contact) }}">
                    {{ initialsForContact(contact) }}
                  </span>
                  @if (contact.isOwner) {
                    <aiwyn-icon
                      name="star"
                      class="rail-avatar-star"
                      [height]="12"
                      [width]="12"
                      aria-label="Client owner"
                    ></aiwyn-icon>
                  }
                </span>
                <div class="rail-person-text">
                  @if (contact.name) {
                    <div class="rail-person-name-row">
                      <p class="rail-person-name">{{ contact.name }}</p>
                      @if (isCurrentUser(contact)) {
                        <pill color="primary" size="small" value="YOU"></pill>
                      }
                    </div>
                    <p class="rail-person-email">{{ contact.email ?? '' }}</p>
                  } @else {
                    <div class="rail-person-name-row">
                      <p class="rail-person-email">{{ contactFallbackLabel(contact) }}</p>
                      @if (isCurrentUser(contact)) {
                        <pill color="primary" size="small" value="YOU"></pill>
                      }
                    </div>
                  }
                </div>
                @if (canRemove(contact)) {
                  <button
                    type="button"
                    class="rail-remove"
                    [attr.aria-label]="'Remove ' + (contact.name || contact.email || 'this person')"
                    [dataSelector]="'cxp-crl-overlay-rail-remove'"
                    (click)="removeContact.emit(contact)"
                  >
                    <aiwyn-icon name="prohibit" namespace="phosphor" [height]="24" [width]="24"></aiwyn-icon>
                  </button>
                }
              </div>
            } @empty {
              <p class="rail-empty">No client recipients on file.</p>
            }
          </div>
        </div>

        @if (isRestricted()) {
          <div class="rail-privacy" [dataSelector]="'cxp-crl-overlay-rail-privacy'">
            <aiwyn-icon name="lock" class="rail-privacy-icon" [height]="14" [width]="14"></aiwyn-icon>
            <span class="rail-field-value">Restricted</span>
          </div>
        }
      </div>
    }
  </section>

  <section class="rail-card">
    <button
      type="button"
      class="rail-card-header"
      [attr.aria-expanded]="activityExpanded()"
      [dataSelector]="'cxp-crl-overlay-rail-activity-toggle'"
      (click)="toggleActivity()"
    >
      <h3 class="rail-card-title">Latest Activity</h3>
      <aiwyn-icon
        class="rail-card-chevron"
        [class.rail-card-chevron-expanded]="activityExpanded()"
        name="chevron-down"
        [height]="16"
        [width]="16"
      ></aiwyn-icon>
    </button>

    @if (activityExpanded()) {
      <div class="rail-card-body rail-activity-body">
        <cxp-crl-panel-activity
          [activity]="activity()"
          [isLoading]="activityLoading()"
          [showTitle]="false"
          (previewFile)="previewActivityFile.emit($event)"
          (downloadFile)="downloadActivityFile.emit($event)"
        />
        <button
          type="button"
          class="rail-view-all"
          [dataSelector]="'cxp-crl-overlay-view-all-activity'"
          (click)="viewAllActivity.emit()"
        >
          View All Activity
        </button>
      </div>
    }
  </section>
</aside>
